import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PORTRAIT_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_lakeview-music/artifacts/2lbqxd6e_Greg%20Hammer_Credit_Corina%20Marie%20%281%29.webp";

const fieldClass =
  "rounded-none border-foreground/30 bg-transparent text-base placeholder:text-foreground/40 focus-visible:border-foreground focus-visible:ring-0 focus-visible:ring-offset-0";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const update = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Message sent — Greg will be in touch soon.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="border-t border-border">
      <div className="mx-auto grid max-w-6xl gap-16 px-6 py-24 sm:py-32 md:grid-cols-2">
        <div>
          <Reveal>
            <p className="text-xs font-medium tracking-[0.35em] uppercase text-foreground/60">
              Contact
            </p>
            <h2 className="mt-6 font-serif text-3xl font-normal tracking-tight sm:text-4xl">
              Let's talk about your music.
            </h2>
            <p className="mt-8 max-w-md text-base leading-relaxed text-foreground/80">
              Tell Greg a little about yourself and what you're working on.
              Every inquiry is read personally — no assistants, no forms that
              go nowhere.
            </p>
            <div className="relative mt-14 max-w-xs">
              <div className="absolute -left-4 -top-4 h-full w-full border border-border" />
              <img
                src={PORTRAIT_URL}
                alt="Greg Hammer, founder of Lakeview Music"
                data-testid="contact-portrait"
                className="relative w-full border border-foreground/20 object-cover"
              />
              <p className="mt-4 text-xs tracking-[0.2em] uppercase text-foreground/60">
                Greg Hammer, Founder
              </p>
              <p className="mt-1 text-xs text-foreground/40">
                Photo: Corina Marie
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <form data-testid="contact-form" onSubmit={submit} className="space-y-6">
            <Input
              required
              value={form.name}
              onChange={update("name")}
              placeholder="Your name"
              data-testid="contact-name-input"
              className={fieldClass}
            />
            <Input
              required
              type="email"
              value={form.email}
              onChange={update("email")}
              placeholder="Your email"
              data-testid="contact-email-input"
              className={fieldClass}
            />
            <Textarea
              required
              rows={6}
              value={form.message}
              onChange={update("message")}
              placeholder="What are you working on?"
              data-testid="contact-message-input"
              className={fieldClass}
            />
            <button
              type="submit"
              disabled={sending}
              data-testid="contact-submit-button"
              className="w-full border border-primary bg-primary px-8 py-4 text-xs font-medium tracking-[0.2em] uppercase text-primary-foreground transition-colors duration-300 hover:bg-secondary hover:text-secondary-foreground disabled:opacity-50"
            >
              {sending ? "Sending…" : "Send message"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
